import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';

const isDebug = process.env.REACT_APP_MIXPANEL_DEBUG;

const useMixPanel = () => {
  useEffect(() => {
    const token = process.env.REACT_APP_MIXPANEL_TOKEN;

    if (token) {
      mixpanel.init(token, {
        debug: isDebug === 'true' ? true : false,
        track_pageview: false,
        persistence: 'localStorage',
      });
    } else {
      console.error('Mixpanel token is missing.');
    }
  }, []);

  const trackEvent = (eventName, properties = {}) => {
    // Don't track anything if Mixpanel hasn't been initialized properly
    if (!mixpanel?.track || !process.env.REACT_APP_MIXPANEL_TOKEN) return;
    mixpanel.track(eventName, properties);
  };

  const setUser = (userId, properties = {}) => {
    if (!mixpanel?.identify) return;
    mixpanel.identify(userId);
    mixpanel.people?.set?.(properties);
  };

  return { trackEvent, setUser };
};

export default useMixPanel;
